<!--
 * @Author: Src
 * @Date: 2024-12-18 09:26:58
 * @LastEditTime: 2024-12-25 10:17:20
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/shop/comments/TimePickerField.vue
 * @Description: 头部注释配置模板
-->
<template>
    <div>
        <el-time-picker is-range v-model="val" :editable="false" range-separator="至" start-placeholder="开始时间"
            end-placeholder="结束时间" placeholder="选择时间范围" format="HH:mm" value-format="HH:mm" style="width: 40vw" >
        </el-time-picker>
    </div>
</template>
<script lang="ts">
import { Vue, Component, Model, Watch } from 'vue-property-decorator';

@Component({})
export default class TimePickerField extends Vue {
    val: any = '';

    @Watch('val')
    watchInternalVal(): void {
        console.log(this.val);

        if (this.val.length > 0) {
            const startTime = `${this.val[0]}`;
            const endTime = `${this.val[1]}`;
            this.$emit('change', `${startTime}-${endTime}`);
        } else {
            this.$emit('change', '');
        }
    }


    @Model('change', {
        type: String,
    })
    value!: string;

    @Watch('value')
    watchValue() {
        if (!this.value || this.value === '') {

            this.val = [new Date('2024-12-20 08:00:00'), new Date('2024-12-20 20:00:00')];
            return;
        } else {
            const [startTime, endTime] = this.value.split('-');
            const startDate = new Date(`2024-12-20 ${startTime}:00`);
            const endDate = new Date(`2024-12-20 ${endTime}:00`);
            // this.val = [startDate, endDate];
            this.val = [startTime, endTime];
        }
    }

    mounted() {
        this.watchValue();

    }
}
</script>
